var amdi18n={"__root":{"revokation_of_cloud_identities":"Revokation of Cloud Identities","information_text":"Please choose the credential, which should be used for the revokation of the derived Cloud Identities:","no_usable_identity_available":"No usable identity available","not_available":"not available","not_supported":"not supported"},"__de":{"revokation_of_cloud_identities":"Sperrung von Cloud Identitäten","information_text":"Bitte wählen Sie den Ausweis, der zur Sperrung der aus ihm abgeleiteten Cloud Identitäten genutzt werden soll:","no_usable_identity_available":"Keine passende Identität verfügbar","not_available":"nicht verfügbar","not_supported":"nicht unterstützt"}};amdi18n.init=function(language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;


//////////////////
// WEBPACK FOOTER
// ./node_modules/amdi18n-loader!./src/main/web/js/app/state/nls/IdentitiesRevokationState_strings.js
// module id = 346
// module chunks = 3